import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function Diagnosis({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriDiagnosis: answers.xcopriDiagnosis }}
          onSubmit={(newAnswers) => onSubmit({ ...answers, xcopriDiagnosis: newAnswers.xcopriDiagnosis })}
          onBack={onBack}
          title={`How long have you (or the patient) been diagnosed with epilepsy? Provide your best guess.`}
          keyForAnswer={`xcopriDiagnosis`}
          choices={[
            '0 - 1 years',
            '1 - 5 years',
            '5 - 10 years',
            '10 years or more',
            'Have not been diagnosed with epilepsy',
          ]}
          selectOne
          showOther={false}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
